import {V3Record} from 'data/helpers/V3Record.js'

export const AppCode = V3Record('appCode', {
  createdAt: null,
  code: null,
  active: null
})
